<div class="debug-page">
  <nb-card>
    <nb-card-header>Environment</nb-card-header>
    <nb-card-body>
      <p><b>Tag: </b>{{ currentEnvironment.tag }}</p>
      <p><b>Api-Url: </b>{{ currentEnvironment.apiUrl }}</p>
      <p><b>Store-Version: </b>{{ currentEnvironment.storeVersion }}</p>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>Sentry</nb-card-header>
    <nb-card-body>
      <button nbButton (click)="throwTestError()">Test Sentry Error</button>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>Sensors</nb-card-header>
    <nb-card-body>
      <button nbButton (click)="startSensorCleaning()">Start sensor cleaning</button>
    </nb-card-body>
  </nb-card>

  <nb-card class="import-card">
    <nb-card-header>Claude Protocol Import</nb-card-header>
    <nb-card-body>
      <p class="step-label"><b>Schritt 1:</b> Guideline herunterladen und zusammen mit dem PDF-Protokoll an Claude übergeben. Die Guideline enthält auch Anweisungen zur automatischen Spaltenbreite (colSpan) der Felder im 12-Spalten-Raster.</p>
      <button nbButton status="info" (click)="downloadGuideline()">Guideline herunterladen</button>

      <hr />

      <p class="step-label"><b>Schritt 2:</b> Claude-Output (JSON) hochladen und importieren.</p>
      <div class="file-row">
        <input type="file" accept=".json" (change)="onFileSelected($event)" />
        <button
          nbButton
          status="primary"
          [disabled]="!selectedFile || importing"
          (click)="importFromClaude()">
          {{ importing ? 'Importiere...' : 'Importieren' }}
        </button>
      </div>

      <div *ngIf="importResult" class="import-result success">
        <p>
          Protokolltyp <b>{{ importResult.protocolTypeName }}</b> wurde erstellt.
        </p>
        <p>
          Felder: <b>{{ importResult.createdFieldCount }}</b> neu erstellt,
          <b>{{ importResult.reusedFieldCount }}</b> wiederverwendet &nbsp;|&nbsp;
          Abschnitte: <b>{{ importResult.createdCollectionCount }}</b> neu erstellt,
          <b>{{ importResult.reusedCollectionCount }}</b> wiederverwendet
        </p>
        <p class="layout-hint">
          <nb-icon icon="grid-outline" pack="eva"></nb-icon>
          Spaltenbreiten wurden von Claude automatisch zugewiesen (¼ für Boolean, ⅓ für Zahlen/Datum, ½ für Text, ↔ für Langtext/Anhänge). Diese können im Abschnitt-Editor angepasst werden.
        </p>
        <button nbButton status="success" (click)="openProtocolType(importResult.protocolTypeId)">
          Protokolltyp öffnen
        </button>
      </div>

      <div *ngIf="importError" class="import-result error">
        <p><b>Fehler:</b> {{ importError }}</p>
      </div>
    </nb-card-body>
  </nb-card>
</div>
